import React from 'react';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  height: theme.margin.xxlarge,
  width: '100%',
  flexShrink: 0,
  background: 'linear-gradient(180deg, rgba(37, 37, 37, 0.00) 0%, #252525 100%)',
  pointerEvents: 'none',
});

const BottomShadow = () => {
  const { css } = useFela();

  return (
    <div className={css(rules)} />
  );
};

export default React.memo(BottomShadow);
